module.exports = __webpack_public_path__ + "static/media/1463694_593947067326180_6295988_n.decb5167.jpg";